
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/browser-bookmark",
      function () {
        return require("private-next-pages/android/browser-bookmark/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/browser-bookmark"])
      });
    }
  